/* QUELL - comportements communs. Un seul role pour l instant :
   les boutons marques data-qll-top remontent en haut de page en douceur.
   On passe par la propriete CSS scroll-behavior et non par l option
   behavior de scrollTo : certains navigateurs ignorent la seconde. */
(function(){
  var minuteur = null;

  function haut(){
    var doc = document.documentElement;
    var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!doux){ window.scrollTo(0, 0); return; }
    if(minuteur){ clearTimeout(minuteur); }
    var avant = doc.style.scrollBehavior;
    doc.style.scrollBehavior = 'smooth';
    window.scrollTo(0, 0);
    minuteur = setTimeout(function(){
      doc.style.scrollBehavior = avant;
      minuteur = null;
    }, 1200);
  }

  function init(){
    document.addEventListener('click', function(ev){
      var cible = ev.target;
      if(!cible || !cible.closest) return;
      var b = cible.closest('[data-qll-top]');
      if(!b) return;
      ev.preventDefault();
      haut();
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
